<template>
    <v-dialog-old
        @hidden="cancel" :onCloseEsc="closeModal"
        ref="exportDoctorsDialog"
        class="glue"
        :special-styles="{ width: '650px' }"
    >
        <ValidationObserver ref="validator">
            <fieldset>
                <legend>Экспорт врачей клиники / сети</legend>
                <form>
                    <vee-input v-model="url"
                               rules="required"
                               placeholder="URL клиники / сети"
                               :input-class="{'hasError': error}"
                               v-tooltip.bottom-end="{
                                  content: url && error ? error : null,
                                  template: tooltipTemplate(),
                               }"/>
                    <button style="margin-top: 11px;" @click.prevent="exportDoctors">Экспортировать</button>
                </form>
            </fieldset>
        </ValidationObserver>
    </v-dialog-old>
</template>
<script>

export default {
    data(){
        return {
            url: '',
            processing: false,
            error: null,
        }
    },
    methods:{
        show() {
            this.$refs.exportDoctorsDialog.show()
        },
        cancel() {
            this.url = ''
            this.processing = false
            this.error = null
        },
        closeModal() {
            this.cancel()
            this.$refs.exportDoctorsDialog.hide()
        },
        tooltipTemplate ()  {
            return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
        },
        exportDoctors(){
            this.error = null;
            this.$refs.validator.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }

                this.processing = true;

                window.open(`tools/get-report/doctors?url=${this.url}`)

                this.closeModal()
            })
        }
    }
}
</script>
